import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API_BASE } from "../lib/api";

const DEFAULT_COMPANY = {
    ragione_sociale: "Splendor Sud S.r.l.",
    tagline: "Sanificazioni e Pulizie - dal 1970",
    sede: "Via Abruzzo, 1, 74121 - Taranto",
    p_iva: "IT 00090240730",
};

const CompanyContext = createContext(DEFAULT_COMPANY);

export const CompanyProvider = ({ children }) => {
    const [company, setCompany] = useState(DEFAULT_COMPANY);

    useEffect(() => {
        let cancelled = false;
        axios
            .get(`${API_BASE}/company`)
            .then((res) => {
                if (!cancelled && res.data) setCompany(res.data);
            })
            .catch(() => {
                /* keep defaults */
            });
        return () => {
            cancelled = true;
        };
    }, []);

    return <CompanyContext.Provider value={company}>{children}</CompanyContext.Provider>;
};

export const useCompany = () => useContext(CompanyContext);
